import cloneDeep from "lodash/cloneDeep";

const ADDRESS_TYPES = ["partner", "processing"];

function stripCoordinateField(entity = {}) {
  const cloneEntity = entity;
  delete cloneEntity.coordinate;

  return cloneEntity;
}

function buildAddresses(model = {}) {
  const typeArray = Array.isArray(model.types)
    ? model.types
    : model.types
      ? [model.types]
      : [];
  const selectedTypes = typeArray.map((type) => (type || "").toString().toLowerCase());
  return ADDRESS_TYPES.reduce((acc, customerType) => {
    if (!selectedTypes.includes(customerType)) {
      return acc;
    }

    const entry = model[customerType];
    if (!entry) {
      return acc;
    }

    acc.push({
      ...stripCoordinateField(entry),
      type: customerType,
    });
    return acc;
  }, []);
}

function sanitizeFarms(farms = []) {
  return farms.filter(Boolean).map((farm) => stripCoordinateField(farm));
}

export function buildCustomerPayload(model) {
  if (!model) {
    return {};
  }

  const cloned = cloneDeep(model);
  const payload = {
    ...cloned,
    addresses: buildAddresses(cloned),
  };

  ADDRESS_TYPES.forEach((key) => {
    delete payload[key];
  });

  const finalType = Array.isArray(payload.types)
    ? payload.types
    : payload.types
      ? [payload.types]
      : [];
  if (!finalType.includes("farmer")) {
    delete payload.farms;
  } else {
    payload.farms = sanitizeFarms(payload.farms);
  }

  return payload;
}
